import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import en from './en.json'
import ja from './ja.json'
import ko from './ko.json'
import vi from './vi.json'
import zhCn from './zhCn.json'
import zhTw from './zhTw.json'

const resources = {
  en: {
    translation: en,
  },
  ja: {
    translation: ja,
  },
  ko: {
    translation: ko,
  },
  // 베트남어
  vi: {
    translation: vi,
  },
  // 중국어 간체
  'zh-CN': {
    translation: zhCn,
  },
  // 중국어 번체
  'zh-TW': {
    translation: zhTw,
  },
}
const lng = window.navigator.language === 'und' ? 'ko' : window.navigator.language

i18n.use(initReactI18next).init({
  resources,
  lng,
  fallbackLng: {
    default: ['ko-KR'],
  },
  interpolation: {
    escapeValue: false,
  },
})

export default i18n
